import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { TruckLocation } from "../types/logisticsMapTypes.ts"

export const getTruckLocations = async (): Promise<TruckLocation[]> => {
  const res = await authFetch(`${API_BASE}/logistics/locations`)
  const data: TruckLocation[] = await res.json()
  return data.filter((truck) => truck.number != "Unknown")
}
